import * as React from 'react';
import Main from "../components/Main";
import {Col, Row} from "react-bootstrap";
import karta from "./../images/karta_klienta_KSK.png";
import kartaProfi from "./../images/karta_klienta_profi.png";

const KartyProfity = () => {
    return(
        <Main active={'KARTY_PROFITY'}>
            <div className={'kartyProfity'}>
            <Row>
                <Col className={'colLeft'}>
                    <div style={{position: 'relative'}}>
                        <img src={karta} style={{width: '100%'}}/>
                        <div style={{position: 'absolute', bottom: '5px', left: '10px', color: 'white', fontSize: '1.8vw'}}>
                            Karta Stałego Klienta
                            <h5 style={{fontSize: '2vw', fontWeight: 'bold', margin: '0'}}>DLA KAŻDEGO</h5>
                        </div>
                    </div>
                    <div className={'boxKartyProfity'} style={{color: 'red'}}>
                        <span style={{fontSize: '16px', fontWeight: 'bold'}}>Rabaty do</span>
                        <div style={{fontSize: '8vw', fontWeight: 'bold', textAlign: 'center'}}>10%</div>
                    </div>
                    <div className={'boxKartyProfity'} style={{color: 'black'}}>
                        <div className={'srednie'}>Dostęp do aktualnych promocji</div>
                        <div className={'srednie'}><b>Kupuj taniej z kartą</b></div>
                        <div className={'male'}>(towary oznaczone w sklepach stacjonarnych)</div>
                        <div className={'srednie'}><b>Kupuj taniej z kuponem</b></div>
                    </div>
                    <div className={'boxKartyProfity'} style={{color: 'black'}}>
                        <div className={'srednie'}>Szybkie i łatwe zakupy w aplikacji</div>
                        <div className={'male'}>Z dostawą do domu lub z odbiorem w sklepie stacjonarnym</div>
                    </div>
                    <div className={'boxKartyProfity'} style={{color: 'black'}}>
                        <div className={'srednie'}>Dostęp do historii zakupów</div>
                        <div className={'male'}>Kontrolujesz swoje wydatki</div>
                    </div>
                    <div className={'regulamin'}>
                        Sczegóły promocji dostępne <b>w regulaminie Programu Lojalnościowego "Karta Stałego Klienta"</b>
                    </div>
                </Col>
                <Col className={'colRigth'}>
                    <div style={{position: 'relative'}}>
                        <img src={kartaProfi} style={{width: '100%'}}/>
                        <div style={{position: 'absolute', bottom: '5px', left: '10px', color: 'white', fontSize: '1.8vw'}}>
                            Karta Stałego Klienta
                            <h5 style={{fontSize: '2vw', fontWeight: 'bold', margin: '0'}}>DLA FIRM - PROFI</h5>
                        </div>
                    </div>
                    <div className={'boxKartyProfity'} style={{color: 'black'}}>
                        <div style={{fontSize: '5vw', fontWeight: 'bold', textAlign: 'center'}}><span style={{fontSize: '16px'}}>Rabaty do </span> 7%</div>
                        <div style={{fontSize: '5vw', fontWeight: 'bold', textAlign: 'center'}}><span style={{fontSize: '16px'}}>+ Bon w aplikacji </span> 5%</div>
                        <div className={'male'}>Zbieraj punkty i wymieniaj bon rabatowy</div>
                    </div>
                    <div className={'boxKartyProfity'} style={{color: 'black'}}>
                        <div className={'srednie'}>Dostęp do aktualnych promocji</div>
                        <div className={'srednie'}><b>Kupuj taniej z kartą</b></div>
                        <div className={'male'}>(towary oznaczone w sklepach stacjonarnych)</div>
                        <div className={'srednie'}><b>Kupuj taniej z kuponem</b></div>
                    </div>
                    <div className={'boxKartyProfity'} style={{color: 'black'}}>
                        <div className={'srednie'}>Szybkie i łatwe zakupy w aplikacji</div>
                        <div className={'male'}>Z dostawą do domu lub z odbiorem w sklepie stacjonarnym</div>
                    </div>
                    <div className={'boxKartyProfity'} style={{color: 'black'}}>
                        <div className={'srednie'}>Dostęp do historii zakupów</div>
                        <div className={'male'}>Kontrolujesz swoje wydatki</div>
                    </div>
                    <div className={'boxKartyProfity'} style={{color: 'black'}}>
                        <div className={'srednie'}>Szeroka oferta specjalna</div>
                        <div className={'male'}>Indywidualne wyceny</div>
                    </div>
                    <div className={'boxKartyProfity'} style={{color: 'black'}}>
                        <div className={'srednie'}>Łatwy zwrot towaru</div>
                        <div className={'male'}>Nie wykorzystany towar możesz zwrócić</div>
                    </div>
                    <div className={'boxKartyProfity'} style={{color: 'black'}}>
                        <div className={'srednie'}>Transport w dniu zakupu</div>
                        <div className={'male'}>Liczymy się z Twoim czasem</div>
                    </div>
                    <div className={'regulamin'}>
                        Sczegóły promocji dostępne <b>w regulaminie Programu Lojalnościowego "Merkury Market Profi"</b>
                    </div>
                </Col>
            </Row>
            </div>
        </Main>
    )
}

export default KartyProfity;
